import styled from "@emotion/styled";

export const ReviewClassesDetailPageHeadTitleMain = styled.div`
    align-items: center;
    display: flex;
    gap: 10px;
    width: 50%;
    justify-content: space-between;
    @media (min-width: 1380px) {
        width: 35%;
      }
`;


export const ReviewClassesDetailPageSwitchLabel = styled.label`
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
    & > input { 
        opacity: 0;
        width: 0;
        height: 0;
      }
`;
export const ReviewClassesDetailPageRoundedSlide = styled.span`
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 34px;
    &:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
        border-radius: 50%;
      }
`;
export const ReviewClassesDetailPageSwitchInput = styled.input`
    &:checked + span{
        background-color: #2196F3;
    }
    &:focus + span {
        box-shadow: 0 0 1px #2196F3;
    }
    &:checked + span:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
      }
`;

export const ReviewClassesDetailPageContainer = styled.div`
    display: flex;
    flex-direction: row;
    @media (max-width:1024px) {
        flex-direction: column;
    }
`;

export const ReviewClassesDetailPageListingLabels = styled.p`
    font-family: Inter, sans-serif;
    font-weight: 600;
`;

export const BackButton = styled.a`
    font-size: 0.938rem;
    white-space: nowrap;
    font-family: Helvetica, Arial, sans-serif;
    padding: 0.6em 1.3em;
    border-radius: 0.8em;
    cursor: pointer;
    display: inline-flex;
    appearance: none;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    gap: 0.5em;
    font-weight: 500;
    width: fit-content;
    border: none;
    background-color: rgb(22, 59, 93);
    color: white;
    text-decoration: none;
`;
// Styled components for layout
export const DetailContainer = styled.div`
    display: flex;
    gap: 20px;
    flex-direction: row;
    width: 100%;
    align-items: center;
    justify-content: center;
    @media (max-width: 767px) {
        flex-direction: column;
    }
`;
export const DetailCardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 100%;
    padding: 20px;
    border-radius: 0.8em;
`;
export const DetailCard = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 100%;
    background: white;
    padding: 20px;
    border-radius: 0.8em;
`;